import { useMutation, useQuery } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

//Components
import PreviewButtons from "../../../components/Preview/PreviewButtons/PreviewButtons";
import PreviewFinish from "../../../components/Preview/PreviewFinish/PreviewFinish";
import PreviewFooter from "../../../components/Preview/PreviewFooter/PreviewFooter";
import PreviewHeader from "../../../components/Preview/PreviewHeader/PreviewHeader";
import PreviewQuestions from "../../../components/Preview/PreviewQuestions/PreviewQuestions";
//Redux
import { SetAnswers } from "../../../redux/slice/SurveySlice/AnswerSlice";

//APIs
import { BsChevronCompactDown, BsChevronCompactUp } from "react-icons/bs";
import Loader from "../../../components/Loader/Loader";
import { getSurvey, postAnswers } from "../../../services/ApiServices";
import Error from "../../Error/Error";
import { ChangeLanguageWithValue } from "../../../redux/slice/LanguageSlice/LanguageSlice";

export default function UserSurvey() {
  const { id, lang, scale } = useParams();
  const Answers = useSelector((state) => state.Answers);
  const Survey = useSelector((state) => state.Survey);
  const dispatch = useDispatch();
  const compref = useRef();
  const [ScaleIndex, setScaleIndex] = useState(0);
  const [page, setpage] = useState(-1);
  const [scrool, setscrool] = useState(-1);
  const [OKform, setOKform] = useState(false);
  const [scrollList, setscrollList] = useState([]);
  const [Height, setHeight] = useState([]);
  const TitleFontScales = [
    "text-xl md:text-[28px]  lg:text-[28px]",
    "text-[33px]",
    "text-[38px]",
    "text-[43px]",
    "text-[48px]",
  ];
  const TitleDescriptionFontScales = [
    " 2xl:text-sm ",
    "text-[15px]",
    "text-[16px]",
    "text-[20px]",
    "text-[24px]",
  ];
  const QuestionFontScales = [
    "text-2xl",
    "text-[34px]",
    "text-[38px]",
    "text-[43px]",
    "text-[48px]",
  ];
  const QuestionDescriptionFontScales = [
    "text-md ",
    "text-[33px]",
    "text-[38px]",
    "text-[43px]",
    "text-[48px]",
  ];
  const AnswersFontScales = [25, 30, 35, 40, 48];
  const InputAnswersFontScales = [
    "text-md ",
    "text-[33px]",
    "text-[38px]",
    "text-[43px]",
    "text-[48px]",
  ];

  const [requiredList, setrequiredList] = useState([]);
  const mutation = useMutation(postAnswers, {
    onSuccess: (value) => {
      if (value.status === 201) {
        setOKform(true);
      }
    },
  });
  const { isLoading, error, data, refetch } = useQuery(
    ["getSurvey"],
    getSurvey.bind(null, id),
    {
      refetchOnWindowFocus: false,
      onSuccess: (value) => {
        setTimeout(() => {
          ConvertAnswerJson(value);
        }, 100);
      },
    }
  );

  useEffect(() => {
    setTimeout(() => {
      if (!!data) {
        let scrool = [];
        data.data.questions.forEach((element, index) => {
          const listDom =
            document.getElementsByClassName("questions-items")[index];
          if (!!listDom) {
            scrool.push(listDom.offsetTop - 150);
          }
        });
        setscrollList(scrool);
      }
    }, 1000);
  }, [data]);

  useEffect(() => {
    for (let index = 0; index < scrollList.length; index++) {
      if (
        scrollList[index] <= parseInt(scrool) &&
        scrollList[index + 1] > parseInt(scrool)
      ) {
        setpage(index);
        break;
      }
    }
  }, [scrool]);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setscrool(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (scale == undefined) {
      setScaleIndex(0);
    } else if (scale >= 5) {
      setScaleIndex(4);
    } else if (scale < 0) {
      setScaleIndex(0);
    } else {
      setScaleIndex(scale);
    }
  }, [scale]);

  useEffect(() => {
    if (lang != undefined) {
      dispatch(ChangeLanguageWithValue(lang));
    } else {
      dispatch(ChangeLanguageWithValue("tr"));
    }
  }, [lang]);

  if (isLoading) return <Loader />;

  if (error || data.data.questions.length === 0)
    return (
      <Error
        error={!!error && error.message}
        code={!!error && error.request.status}
        text={"Giriş Ekranına Geri Dön "}
        historylink={"/"}
      />
    );

  //Conver Json Data
  function ConvertAnswerJson(value) {
    let answer = [];
    let scrool = [];
    let required = [];
    let height = [];
    value.data.questions.forEach((element, index) => {
      answer.push({
        question_id: element._id,
        answer_type: element.question_type,
        answer_value: null,

        //unutma
        answer_required: element.required,
      });
      required.push(true);
      const listDom = document.getElementsByClassName("questions-items")[index];
      if (!!listDom) {
        height.push(listDom.offsetHeight);
        scrool.push(listDom.offsetTop - 150);
      }
    });

    let json = {
      survey: id,
      answers: answer,
    };
    setrequiredList(required);
    setscrollList(scrool);
    setHeight(height);
    dispatch(SetAnswers(json));
  }

  function FinishSurvey() {
    var finishState = true;
    let requiredlist = [...requiredList];
    for (let index = 0; index < Answers.Answers.answers.length; index++) {
      if (Answers.Answers.answers[index].answer_required === true) {
        if (
          Answers.Answers.answers[index].answer_value === null ||
          Answers.Answers.answers[index].answer_value === ""
        ) {
          requiredlist[index] = false;

          window.scrollTo({
            top: scrollList[index],
            behavior: "smooth",
          });
          finishState = false;
          break;
        } else {
          if (Answers.Answers.answers[index].answer_type === "multi") {
            var truestate = Answers.Answers.answers[index].answer_value.filter(
              (e) => e === true
            );
            if (truestate.length === 0) {
              requiredlist[index] = false;

              window.scrollTo({
                top: scrollList[index],
                behavior: "smooth",
              });
              finishState = false;
              break;
            }
          }
          requiredlist[index] = true;
        }
      }
    }

    setrequiredList(requiredlist);
    if (finishState) {
      mutation.mutate(Answers.Answers);
    }
  }

  function QuestionDown() {
    if (page + 1 < scrollList.length) {
      console.log("scrollist:",scrollList);
      
      window.scrollTo({
        top: scrollList[page + 1],
        behavior: "smooth",
      });
      setpage(parseInt(page + 1));
    }
  }
  function QuestionUp() {
    if (page - 1 !== -1) {
      window.scrollTo({
        top: scrollList[page - 1],
        behavior: "smooth",
      });
      setpage(parseInt(page - 1));
    }
  }

  function OnClikQuestionDown(index) {
    if (index + 1 < scrollList.length) {
      window.scrollTo({
        top: scrollList[index + 1],
        behavior: "smooth",
      });
      setpage(parseInt(index + 1));
    }
  }

  function onFocusInput(index) {
    if (index + 1 < scrollList.length) {
      window.scrollTo({
        top: scrollList[index],
        behavior: "smooth",
      });
      setpage(parseInt(index));
    }
  }
  const totalQuestion = data.data.questions.length;
  return (
    <>
      {!OKform ? (
        <div className="w-full h-full flex flex-col justify-center items-center bg-white z-9999" style={{marginTop:'200px',marginBottom:"100px"}}>
          <div className="application">
            <Helmet>
              <meta charSet="utf-8" />
              {/* <title>{data.data.title}</title> */}
            </Helmet>
          </div>

          <PreviewHeader
            title={data.data.title}
            description={data.data.description}
            id={id}
            TitleFontScales={TitleFontScales[ScaleIndex]}
            TitleDescriptionFontScales={TitleDescriptionFontScales[ScaleIndex]}
            lang={lang}
            headerBackgroundPath={data.data.headerBackgroundImagePath}
            totalCount={totalQuestion}
          />
          <div className="mt-8 w-full">
            {totalQuestion > 1 ? 
              <div className="fixed top-20 right-6 z-10 cursor-pointer" style={{marginTop:'90px'}}>
                <BsChevronCompactUp
                  size={70}
                  className="text-[#3885f4] "
                  onClick={() => QuestionUp()}
                />
              </div>
              :""
            }
            
            {totalQuestion > 1 ? 
              <div
                className={
                  Survey.inputFocus
                    ? "fixed bottom-[50%] right-6 z-10 cursor-pointer transition-all"
                    : "fixed bottom-4 right-6 z-10 cursor-pointer "
                }
                style={{marginBottom:'100px'}}
              >
                <BsChevronCompactDown
                  size={70}
                  className="text-[#3885f4] "
                  onClick={() => QuestionDown()}
                />
              </div>
              :""
            }

            {data.data.questions.map((element, index) => {
              const totalQuestions = data.data.questions.length;
              return (
                <div
                  id="questions-items"
                  className="w-full questions-items"
                  key={index}
                  ref={compref}
                >
                  <PreviewQuestions
                    index={index}
                    title={element.title}
                    description={element.description}
                    options={element.options}
                    tpye={element.question_type}
                    emoji={element.emoji}
                    firstEmojiUrl={element.firstEmojiUrl}
                    secondEmojiUrl={element.secondEmojiUrl}
                    bgrequired={requiredList[index]}
                    required={element.required}
                    onChangeSingle={() => OnClikQuestionDown(index)}
                    onFocusInput={() => onFocusInput(index)}
                    QuestionFontScales={QuestionFontScales[ScaleIndex]}
                    QuestionDescriptionFontScales={
                      QuestionDescriptionFontScales[ScaleIndex]
                    }
                    AnswersFontScales={AnswersFontScales[ScaleIndex]}
                    InputAnswersFontScales={InputAnswersFontScales[ScaleIndex]}
                    totalIndex={totalQuestions}
                  />
                </div>
              );
            })}
          </div>
          <PreviewButtons
            onSuccesClick={() => FinishSurvey()}
            AnswersFontScales={AnswersFontScales[ScaleIndex]}
          />
          <PreviewFooter footerBackgroundPath={data.data.footerBackgroundImagePath}/>
        </div>
      ) : (
        <div className="w-screen h-screen items-center justify-center self-center bg-white py-10">
          <PreviewFinish
            onReturnSurvey={() => (setOKform(false), refetch(), setpage(-1))}
          />
        </div>
      )}
    </>
  );
}
